// [Lot 5d migration AJAX] appels bascules sur api.request (handler d'erreur centralise ajax-error).
const api = require('./modules/api');
const { isValidFileNumber, isValidNumberTier } = require('./modules/connexion-credential-validators');
"use strict";
var getLocale = $(".btn-aid-item").attr("data-local");
var tah_lang = false;
if (getLocale === 'tah'){
    tah_lang = true;
}

var trad_required  = "Ce champ est obligatoire";
var trad_email  = "Veuillez saisir une adresse e-mail valide.";
var trad_num  = "Veuillez saisir un numéro de dossier valide.";
if (tah_lang){
    trad_required  = "Mea fa’ahepohia ‘ia fa’a’ī i teie ārea";
    trad_email  = "A patapata mai i te hō’ē nohora’a ‘īmere mana";
    trad_num  = "A patapata i te hō’ē nūmera pu’e parau mana";
}

jQuery(function ($) {

    const activeAccountModal = $('#active_account_modal');
    const activeAccountModalDemandeur = $('#active_account_modal_demandeur');
    const formActivateLocataire = $(`#locataire_active_account_form`);
    const formActivateDemandeur = $(`#demandeur_active_account_form`);
    const accountCreatedModal = $(`#locataire_created_dialog`);
    const accountNotExistedMessage = $(`.forgot-password-username-not-found-message`);
    var getIdButton;

    /**
     * Action click show form area
     */
    $("body").on("click", ".select-profil-block__inner .btn-aid-item", function () {
        var _this = $(this);

        getIdButton = _this.attr("id");

        var num_tiers = "Numéro tiers";
        var num_dossier = "Numéro de dossier";
        var trad_erreur_saisie = "Veuillez vérifier les informations saisies.";
        var trad_num_dossier_erreur = "Numéro de dossier n'existe pas";
        var trad_yr_num_dossier = "Votre numéro de dossier";
        var trad_presta_oph = "de prestataire OPH.";
        var trad_locataire_oph = "de locataire.";
        var trad_etudiant_oph = "de d'étudiant";
        var trad_etudiant_num = "Numéro d'étudiant";
        var trad_etudiant_num_erreur = "Numéro d'étudiant n'existe pas";
        var trad_yr_mail = "Votre email";

        if (tah_lang){
            num_tiers = "Nūmera tiers";
            num_dossier = "Nūmera pu’e parau";
            trad_erreur_saisie = "A hi’opo’a i te mau parau i patapatahia";
            trad_num_dossier_erreur = "Aita teie nūmera pu’e parau e vai nei";
            trad_yr_num_dossier = "Tā ‘oe nūmera pu’e parau";
            trad_presta_oph = "taiete rave ‘ohipa OPH";
            trad_locataire_oph = "ta’ata tārahu nohora’a";
            trad_etudiant_oph = "pīahi";
            trad_etudiant_num = "Nūmera pīahi";
            trad_etudiant_num_erreur = "Aita teie nūmera pīahi e vai nei";
            trad_yr_mail = "Tā ‘oe ‘īmere";
        }

        var usernameInput = $(`.username-placeholder`);

        if (getIdButton === 'demandeur') {
            usernameInput.text(num_dossier);
            $(`.locataire.btn_active_account`).addClass('d-none');
            $(`.demandeur.btn_active_account`).removeClass('d-none');
            var newNameDemandeur = 'file_number';
            usernameInput.closest(`.form-group`).find('.form-control').attr('name', newNameDemandeur);
            $(`.forgot_password_indication`).text("de dossier.");
            $(`.forgot_password_username_placeholder`).text(num_dossier);
            accountNotExistedMessage.text(trad_num_dossier_erreur);
        }

        if (getIdButton === 'locataire') {
            usernameInput.text(num_dossier);
            $(`.demandeur.btn_active_account`).addClass('d-none');
            $(`.locataire.btn_active_account`).removeClass('d-none');
            var newNameLocataire = 'code_dossier';
            //INPUT FIELD USERNAME
            usernameInput.closest(`.form-group`).find('.form-control').attr('name', newNameLocataire);
            $(`.forgot_password_indication`).text(trad_locataire_oph);
            $(`.forgot_password_username_placeholder`).text(trad_yr_num_dossier);
            accountNotExistedMessage.text(trad_erreur_saisie);
        }

        if (getIdButton === 'prestataires') {
            $(`.card-compte-tiers`).show();
            usernameInput.text(num_tiers);
            $(`.btn_active_account`).addClass('d-none');
            var newNamePrestataires = 'number_tier';
            //INPUT FIELD USERNAME
            usernameInput.closest(`.form-group`).find('.form-control').attr('name', newNamePrestataires);
            $(`.forgot_password_indication`).text(trad_presta_oph);
            $(`.forgot_password_username_placeholder`).text(num_tiers+"OPH");
            accountNotExistedMessage.text(trad_erreur_saisie);
        }else{
            $(`.card-compte-tiers`).hide();
        }

        if (getIdButton === 'etudiants') {
            usernameInput.text(trad_yr_mail);
            $(`.btn_active_account`).addClass('d-none');
            var newNameEtudiants = trad_yr_mail;
            //INPUT FIELD USERNAME
            usernameInput.closest(`.form-group`).find('.form-control').attr('name', newNameEtudiants);
            $(`.forgot_password_indication`).text(trad_etudiant_oph);
            $(`.forgot_password_username_placeholder`).text(trad_etudiant_num);
            accountNotExistedMessage.text(trad_etudiant_num_erreur);
        }

        $(".section-select-profil").addClass("show");
        $(".select-profil-block").addClass("hidden");
        $("form.primary-form").addClass(getIdButton);
        $(".section-select-profil__image[data-id-image=".concat(getIdButton, "]")).addClass("open");
    });

    //CLICK ACTIVATE ACCOUNT
    $(`.locataire.btn_active_account`).on('click', function () {
        $("html, body").animate({
            scrollTop: $("#locataire_active_account_form").offset().top - 50
        }, 200);
        $(`#locataire_active_account_form`).addClass('show');
    });
    $(`.demandeur.btn_active_account`).on('click', function () {
        $("html, body").animate({
            scrollTop: $("#demandeur_active_account_form").offset().top - 50
        }, 200);
        $(`#demandeur_active_account_form`).addClass('show');
    });

    /**
     * Method validate Email
     */
    $.validator.addMethod("validateEmail", function (value, element) {
        return this.optional(element) || /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value);
    });

    $.validator.addMethod("validateFileNumber", function (value, element) {
        return this.optional(element) || isValidFileNumber(value);
    });

    $.validator.addMethod("validateNumberTier", function (value, element) {
        return this.optional(element) || isValidNumberTier(value);
    });

    /**
     * Function handle validate form
     */
    var validatorSelectFrofil = $("#select-profil-form").validate({
        debug: true,
        errorClass: "error",
        errorPlacement: function errorPlacement(error, element) {
            error.appendTo(element.closest(".form-group").next(".error-message")); // replace error to closest 'trinity-form-group'
        },
        ignore: [],
        // ignore all hidden, except element have class 'hidden-required'
        rules: {
            votre_email: {
                required: true,
                validateEmail: true
            },
            file_number: {
                required: true,
                validateFileNumber: true
            },
            number_tier: {
                required: true,
                validateNumberTier: true
            },
            votre_mot_de_passe: {
                required: true
            }
        },
        messages: {
            votre_email: {
                required: trad_required,
                email: trad_email,
                validateEmail: trad_email
            },
            file_number: {
                required: trad_required,
                validateFileNumber: trad_num
            },
            number_tier: {
                required: trad_required,
                validateNumberTier: trad_num
            },
            votre_mot_de_passe: trad_required
        }
    });

    function getFormValues() {
        var formData = new FormData();
        $("form#select-profil-form :input").each(function () {
            var name = $(this).attr('name');
            if (name === "file_number") {
                formData.append('_username', $(this).val());
            }
            if (name === "code_dossier") {
                formData.append('_username', $(this).val());
            }
            if (name === "number_tier") {
                formData.append('_username', $(this).val());
            }
            if (name === "votre_mot_de_passe") {
                formData.append('_password', $(this).val());
            }
            if (name === "_csrf_token") {
                formData.append('_csrf_token', $(this).val());
            }
            if (name === "_submit") {
                formData.append('_submit', $(this).val());
            }
        });
        return formData;
    }
    var authenticateErrorMessage = $(`.custom-authenticate-error-message`);
    $("body").on("click", ".submit-form .btn", function () {
        if (grecaptcha.getResponse() === "") {
            $(`.login-captcha-error`).removeClass("d-none");
        } else {
            $(`.login-captcha-error`).addClass("d-none").removeClass("d-block");
            var isValid = $("#select-profil-form").valid();
            var trad_mdp_controle = "L'identifiant ou le mot de passe est incorrect";
            if (tah_lang) {
                trad_mdp_controle = "Aita te i’oa tomo ‘e aore rā te ta’o tomo i tano";
            }
            if (isValid) {
                $('#loader_div').show();
                var formData = getFormValues();
                $.when(api.request({
                    url: `/login_check`,
                    dataType: 'JSON',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: formData,
                    type: 'post',
                    success: function (data) {},
                    error: function (err) {
                        if(err.status === 429){
                            window.location.reload();
                        }
                        var responseText = (err.responseText);
                        var doc = new DOMParser().parseFromString(responseText, "text/html");
                        var getClassDemandeur = doc.querySelectorAll('.demandeur')[0];
                        var getClassLocataire = doc.querySelectorAll('.locataire-page')[0]; //selector name = body class
                        var getClassPrestataire = doc.querySelectorAll('.prestataire-page')[0]; //selector name = body class
                        var loginError = doc.querySelectorAll('.authenticate-error-key')[0];
                        if (loginError?.innerText || [500, 403].includes(err.status)) { // Show invalid credentials if server has returned a 403 or 500 error code
                            $('#loader_div').hide();
                            authenticateErrorMessage.text(trad_mdp_controle);
                            authenticateErrorMessage.removeClass("d-none");
                        }

                        var connexion_prestataire_fr = '/prestataire';
                        var connexion_demandeur_fr = '/demande';
                        var connexion_locataire_fr = '/locataire';
                        if (getLocale === 'tah'){
                            connexion_prestataire_fr = '/tah/prestataire';
                            connexion_demandeur_fr = '/tah/demande';
                            connexion_locataire_fr = '/tah/locataire';
                        }
                        setTimeout(function () {
                            // if (getClassDemandeur === undefined && getClassLocataire === undefined) {
                            //     window.location.href = '/connexion';
                            // } else
                            if (getClassDemandeur && $(getClassDemandeur).hasClass("demandeur")) {
                                window.location.href = connexion_demandeur_fr;
                            } else if (getClassLocataire && $(getClassLocataire).hasClass("locataire-page")) {
                                window.location.href = connexion_locataire_fr;
                            } else if (getClassPrestataire && $(getClassPrestataire).hasClass("prestataire-page")) {
                                window.location.href = connexion_prestataire_fr;
                            }
                        }, 1500)
                    }
                })).always(function () {
                    $('#loader_div').hide();
                });
            }
        }
    });

    /**
     * Action click back to select profil
     */
    $(".back-to-select-profil__link .icon").on("click", function () {
        $(".section-select-profil__image").removeClass("open");
        $(".section-select-profil").removeClass("show");
        $(".select-profil-block").removeClass("hidden");
        $(".section-select-profil input[type='text']").val("");
        $(".section-select-profil .form-group").removeClass("is-focused, is-filled");
        $(`.locataire_active_account`).addClass('d-none');
        validatorSelectFrofil.resetForm();
    });
    $("#locataire_active_account_form").validate({
        debug: true,
        errorClass: "error",
        errorPlacement: function errorPlacement(error, element) {
            error.appendTo(element.closest(".form-group").next(".error-message")); // replace error to closest 'trinity-form-group'
        },
        ignore: [],
        // ignore all hidden, except element have class 'hidden-required'
        rules: {
            email_address: {
                required: true,
                validateEmail: true
            },
            dn_number: {
                required: true,
            },
            locataire_number: {
                required: true
            }
        },
        messages: {
            email_address: {
                required: trad_required,
                email: trad_email,
                validateEmail: trad_email
            },
            dn_number: {
                required: trad_required,
            },
            locataire_number: trad_required
        }
    });

    //LOCATAIRE ACCOUNT ACTIVATE
    var inputLocataireNumber;
    var inputLocataireDnNumber;
    var inputLocataireEmail;
    formActivateLocataire.on('submit', function (e) {

        e.preventDefault();

        inputLocataireNumber = $(`#locataire_active_account_form input[name="locataire_number"]`).val();
        inputLocataireDnNumber = $(`#locataire_active_account_form input[name="dn_number"]`).val();
        inputLocataireEmail = $(`#locataire_active_account_form input[name="email_address"]`).val();

        let accountInformation = {
            'number_dossier': inputLocataireNumber,
            'dn_number': inputLocataireDnNumber,
            'email': inputLocataireEmail
        };

        api.request({
            url: `/locataire/account/activate`,
            dataType: 'JSON',
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            data: accountInformation,
            type: 'post',
            headers: {
                'X-CSRF-TOKEN': $('input[name="_csrf_token_activate_locataire"]').attr('value')
            },
            success: function (response) {
                if (response.status === 'success') {
                    activeAccountModal.modal('hide');
                    activeAccountModal.find('form').trigger('reset');
                    accountCreatedModal.modal('show');
                    $(`#resend_demandeur_email`).addClass('d-none');
                    $(`#resend_locataire_email`).removeClass('d-none');
                } else {
                    if (response.code === 'not_found')
                    {
                        $(`.activation-failure-error-message-not-found`).removeClass('d-none');
                        $(`.activation-failure-error-message-existed`).addClass('d-none');
                    } else //response.code === 'existed'
                    {
                        $(`.activation-failure-error-message-existed`).removeClass('d-none');
                        $(`.activation-failure-error-message-not-found`).addClass('d-none');
                    }
                }
            },
            error: function (err) {
            }
        });
    })

    //RESEND EMAIL ACTION LOCATAIRE
    $(`#resend_locataire_email`).on('click', function () {
        $(".loader_div").show();
        var resendEmailInfo = {
            locataireUserId: inputLocataireNumber
        };

        $.when(api.request({
            url: `/locataire/account/email/resend`,
            type: "POST",
            dataType: "JSON",
            headers: {
                'X-CSRF-TOKEN': $('input[name="_csrf_token_activate_locataire"]').attr('value')
            },
            data: resendEmailInfo,
            success: function (data) {
                if (data.status === 'failed') {
                    location.reload();
                }
            }
        })).then(function(){
            $(".loader_div").hide();
        })
    })

    //DEMANDEUR ACCOUNT ACTIVATE
    var inputDemandeurNumber;
    var inputDemandeurDnNumber;
    var inputDemandeurEmail;
    formActivateDemandeur.on('submit', function (e) {

        e.preventDefault();

        inputDemandeurNumber = $(`#demandeur_active_account_form input[name="demandeur_number"]`).val();
        inputDemandeurDnNumber = $(`#demandeur_active_account_form input[name="dn_number"]`).val();
        inputDemandeurEmail = $(`#demandeur_active_account_form input[name="email_address"]`).val();

        let accountInformation = {
            'number_dossier': inputDemandeurNumber,
            'dn_number': inputDemandeurDnNumber,
            'email': inputDemandeurEmail
        };

        api.request({
            url: `/demande/account/activate`,
            dataType: 'JSON',
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            data: accountInformation,
            type: 'post',
            headers: {
                'X-CSRF-TOKEN': $('input[name="_csrf_token_activate_demandeur"]').attr('value')
            },
            success: function (response) {
                if (response.status === 'success') {
                    activeAccountModalDemandeur.modal('hide');
                    activeAccountModalDemandeur.find('form').trigger('reset');
                    accountCreatedModal.modal('show');
                    $(`#resend_demandeur_email`).removeClass('d-none');
                    $(`#resend_locataire_email`).addClass('d-none');
                } else {
                    if (response.code === 'not_found')
                    {
                        $(`.activation-failure-error-message-not-found`).removeClass('d-none');
                        $(`.activation-failure-error-message-existed`).addClass('d-none');
                    } else //response.code === 'existed'
                    {
                        $(`.activation-failure-error-message-existed`).removeClass('d-none');
                        $(`.activation-failure-error-message-not-found`).addClass('d-none');
                    }
                }
            },
            error: function (err) {
            }
        });
    })

    //RESEND EMAIL ACTION DEMANDEUR
    $(`#resend_demandeur_email`).on('click', function () {
        $(".loader_div").show();
        const resendEmailInfo = {
            demandeurUserId: inputDemandeurNumber
        };

        $.when(api.request({
            url: `/demande/account/email/resend`,
            type: "POST",
            dataType: "JSON",
            headers: {
                'X-CSRF-TOKEN': $('input[name="_csrf_token_activate_demandeur"]').attr('value')
            },
            data: resendEmailInfo,
            success: function (data) {
                if (data.status === 'failed') {
                    location.reload();
                }
            }
        })).then(function(){
            $(".loader_div").hide();
        })
    })

    //FORGOT PASSWORD
    const forgotPasswordSection = $(".forgot-password-section");
    const forgotPasswordForm = $(".forgot-password-form");
    const forgotPasswordCompletedSection = $(".forgot-password-complete-section");
    const forgotPasswordErrorMessage = $(".forgot-password-username-not-found");
    $(`.forget-password .action`).on('click', function(){
        $(".section-select-profil").removeClass("show");
        forgotPasswordSection.removeClass("d-none");
        forgotPasswordSection.addClass("d-block");
    });

    forgotPasswordForm.validate({
        debug: true,
        errorClass: "error",
        errorPlacement: function (error, element) {
            error.appendTo(
                element
                    .closest(".form-group")
                    .next(".error-message")
                    .addClass("has")
            );
        }
    });

    $(`input[name="forgot_password_username_input"]`).each(function () {
        $(this).rules("add", {
            required: true,
            messages: {
                required: trad_required
            }
        });
    });

    $(`#forgot-password-request`).on('click', function () {
        if($('input[name=forgot_password_username_input]').val() === "" && $('input[name=forgot_password_username_input]').val() !== ""){
            if (grecaptcha.getResponse() === "") {
                $(`.captcha-error`).removeClass("d-none");
            } else {
                $(`.captcha-error`).addClass("d-none").removeClass("d-block");
            }
        }
        if (forgotPasswordForm.valid()) {
            var path = '/forgot-password';
            if (getLocale === 'tah') {
                path = '/tah/forgot-password';
            }

            var username = $(`input[name="forgot_password_username_input"]`).val();
            var data = {
                'username': username
            };
            api.request({
                    url: path,
                    dataType: 'JSON',
                    contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                    data: data,
                    type: 'post',
                    headers: {
                        'X-CSRF-TOKEN': $('input[name="_csrf_forgot_password_request_token"]').attr('value')
                    },
                    success: function (response) {
                        if (response.status === "success") {
                            forgotPasswordSection.removeClass("d-block");
                            forgotPasswordSection.addClass("d-none");
                            forgotPasswordCompletedSection.removeClass("d-none");
                            forgotPasswordErrorMessage.addClass("d-none");
                            resetForgotPasswordForm();
                        } else {
                            forgotPasswordErrorMessage.removeClass("d-none");
                            if (grecaptcha !== undefined) {
                                grecaptcha.reset();
                            }
                        }
                    }
                }
            )
        }
    })


    function resetForgotPasswordForm(){
        $(`input[name="forgot_password_username_input"]`).val("");
        $(`input[name="forgot_password_username_input"]`).closest(".form-group").removeClass("is-filled");
        if (grecaptcha !== undefined) {
            grecaptcha.reset();
        }
    }

    /**
     * Action click back to current selected profil
     */
    $(".back-to-current-selected-profil__link .icon").on("click", function () {
        $(".section-select-profil").addClass("show");
        forgotPasswordSection.removeClass("d-block");
        forgotPasswordSection.addClass("d-none");
        forgotPasswordCompletedSection.removeClass("d-block");
        forgotPasswordCompletedSection.addClass("d-none");
        validatorSelectFrofil.resetForm();
    });

    /**
     * Uppercase on entered temp demande number
     */
    $(document).on('keyup', "input[name='file_number'],input[name='demandeur_number'],input[name='forgot_password_username_input']", e => {
        console.log(e);
        var start = e.target.selectionStart;
        var end = e.target.selectionEnd;
        e.target.value = e.target.value.toUpperCase();
        e.target.setSelectionRange(start, end);
    })

    /**
     * Uppercase on entered temp demande number admin
     */
    $(document).on('keyup', ".mdp-oublie-username", e => {
        var start = e.target.selectionStart;
        var end = e.target.selectionEnd;
        e.target.value = e.target.value.toLowerCase();
        e.target.setSelectionRange(start, end);
    })

});